// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"delete-user-confirm_deleteIcon__3Glfs"};